import styled from "styled-components";
import { MEDIA_DESKTOP } from "../../../../hooks/useScreenOrientation";

export const NewsWrapper = styled.div<{
  isApp: number | null;
}>`
  display: flex;
  flex-direction: column;
  background: white;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  height: 100vh;
  padding-top: ${(p) => (p.isApp ? `${p.isApp - 10}px` : "0px")};
  @media ${MEDIA_DESKTOP} {
    position: static;
    height: auto;
    max-width: 1060px;
    margin: 0 auto;
    padding: 40px 0;
  }
`;

export const Content = styled.div`
  padding: 48px 12px 56px;

  @media ${MEDIA_DESKTOP} {
    padding: 0 16px 56px;
  }
`;

export const ReadMoreContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0;
  position: relative;
`;

export const Line = styled.div`
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 1px;
  background-color: #ccc;
  z-index: 1;
`;

export const ReadMoreButton = styled.button`
  position: relative;
  background-color: white;
  font-size: 13px;
  font-weight: bold;
  padding: 7px 10px;
  border-radius: 5px;
  cursor: pointer;
  z-index: 2;
  transition: background-color 0.3s, color 0.3s;
  @media ${MEDIA_DESKTOP} {
    font-size: 16px;
  }
`;

export const Header = styled.div<{
  isApp: number | null;
}>`
  position: fixed;
  max-width: 500px;
  z-index: 1000;
  left: 50%;
  transform: translateX(-50%);
  top: 0;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 20px;
  width: 100%;
  min-height: 48px;
  color: #fff;

  font-size: 16px;
  font-weight: 600;
  gap: 10px;
  background: white;
  padding-top: ${(p) => (p.isApp ? `${p.isApp}px` : "0px")};
  padding-bottom: ${(p) => (p.isApp ? "13px" : "0px")};

  .close {
    cursor: pointer;
    width: 24px;
    height: 24px;

    svg path {
      stroke: var(--Black-400, #444);
    }
  }

  .title {
    transition: all 0.1s ease-in-out;
    color: var(--Black-400, #444);

    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`;
